/**
 * Shared :focus-visible ring for Play text actions and sheet controls.
 */
export const playV2FocusRing =
  'rounded-full focus:outline-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgba(251,191,36,0.55)] focus-visible:ring-offset-2 focus-visible:ring-offset-transparent'
